import $ from 'jquery';
import { modifyState } from '~src/state';
import { showSidebarTab, hideSidebarTab } from '~src/sidebarLegacy';
import { updateObjectShadow } from '~src/sidebar/index';

export const handleShadowColorChange = (hexColor) => {
  modifyState('setShadowColorActive', false);
  $('#color-shadow').css('background-color', hexColor);
  hideSidebarTab('colori');
  showSidebarTab('object-shadow');
  updateObjectShadow();
};
